import React, { useMemo } from 'react';
import styles from '../../styles/Pagination.module.scss';

const buildPageItems = (current, total) => {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => ({ type: 'page', value: i + 1 }));
  }

  const pages = new Set([1, total, current, current - 1, current + 1]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const items = [];

  sorted.forEach((page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) {
      items.push({ type: 'ellipsis', value: `gap-${page}` });
    }
    items.push({ type: 'page', value: page });
  });

  return items;
};

const Pagination = ({ page, totalPages, onPageChange }) => {
  const items = useMemo(() => buildPageItems(page, totalPages), [page, totalPages]);

  if (totalPages <= 1) {
    return null;
  }

  return (
    <nav className={styles.pagination} aria-label="Пагінація каталогу">
      <button
        type="button"
        className={styles.arrow}
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        aria-label="Попередня сторінка"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <ul className={styles.pages}>
        {items.map((item) => (
          item.type === 'ellipsis' ? (
            <li key={item.value} className={styles.ellipsis} aria-hidden="true">…</li>
          ) : (
            <li key={item.value}>
              <button
                type="button"
                className={`${styles.pageBtn} ${item.value === page ? styles.pageBtnActive : ''}`}
                onClick={() => onPageChange(item.value)}
                aria-label={`Сторінка ${item.value}`}
                aria-current={item.value === page ? 'page' : undefined}
              >
                {item.value}
              </button>
            </li>
          )
        ))}
      </ul>

      <button
        type="button"
        className={styles.arrow}
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        aria-label="Наступна сторінка"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
          <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>

      <span className={styles.status}>
        Сторінка {page} з {totalPages}
      </span>
    </nav>
  );
};

export default Pagination;
